import api from "../../../../utils/api";
const apiUrl = process.env.REACT_APP_MOCK_RESUME_URL;

export const getSubscriedUser = async (page, limit, tab, paymentFor = '') => {
  try {
    let queryParams = `sortBy=created_at&orderBy=desc&page=${page}&limit=${limit}`;

    if (tab === "MONTHLY" || tab === "YEARLY") {
      queryParams += `&interval=${tab}`;
    } else if (tab === "ONETIME_SUBSCRIPTION"  || tab === "ADDON") {
      queryParams += `&type=${tab}`;
      if (tab === "ONETIME_SUBSCRIPTION") {
        queryParams += `&platFormPayment=true`;
      }
      if (tab === "ADDON" && paymentFor && paymentFor.trim() !== '') {
        queryParams += `&payment_for=${paymentFor}`;
      }
    }

    const res = await api.get(`/customers/user/get-subscribed-users?${queryParams}`, {
      baseURL: apiUrl,
    });

    return res;
  } catch (err) {
    return err;
  }
};